import Config from '../config';
import {Axios} from './';

export class Api {
    static Users = () => UsersApi
    static Auth = () => AuthApi
    static Timesheets = () => TimesheetsApi
    static Axios = () => Axios;
    static Analytics = () => Analytics;
    static Projects = () => Projects;
    static Reports = () => Reports;
    static Clients = () => Clients;
    static Payments = () => Payments;
}

class UsersApi {
    static list(params) {
        return Axios.Api
        .get(`/users`, {params})
    }

    static updateRate(id, data) {
        return Axios.Api
        .post(`/users/${id}/rate`, data, {
            withCredentials: true
        })
    }
}

class AuthApi {
    static signIn(authData) {
        return Axios.Api
        .post(`/authorization/token`, authData);
    }
}

class TimesheetsApi {
    static get(params) {
        return Axios.Api
        .get(`/timesheets`, {
            params
        });
    }
}

class Analytics {
    static UsersPerProject(params) {
        return Axios.Api
        .get(`/analytics/users-per-project`, {
            params
        });
    }

    static ProjectsPerUsers(params) {
        return Axios.Api
        .get(`/analytics/projects-per-users`, {
            params
        });
    }
}

class Projects {
    static list(params) {
        return Axios.Api
        .get(`/projects`, {params})
    }

    static all(params) {
        return Axios.Api
        .get(`/projects/all`, {params})
    }
}

class Reports {
    static get(params) {
        return Axios.Api
        .get(`/reports`, {params})
    }
}

class Clients {
    static all(params) {
        return Axios.Api
        .get(`/clients/all`, {params})
    }
}

class Payments {
    static get(params) {
        return Axios.Api
        .get(`/payments`, {params})
    }

    static post(params) {
        return Axios.Api
        .post(`/payments/post`, {params})
    }
}



// WEBPACK FOOTER //
// ./src/services/Api.service.js